import {
  createContext,
  type ReactNode,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';

type BookingPreset = {
  artistSlug?: string;
  workId?: string;
};

type BookingContextValue = {
  open: boolean;
  preset: BookingPreset;
  openBooking: (preset?: BookingPreset) => void;
  closeBooking: () => void;
};

const BookingContext = createContext<BookingContextValue | null>(null);

export function BookingProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const [preset, setPreset] = useState<BookingPreset>({});

  const openBooking = useCallback((next?: BookingPreset) => {
    setPreset(next ?? {});
    setOpen(true);
  }, []);

  const closeBooking = useCallback(() => {
    setOpen(false);
  }, []);

  const value = useMemo(
    () => ({ open, preset, openBooking, closeBooking }),
    [open, preset, openBooking, closeBooking],
  );

  return <BookingContext.Provider value={value}>{children}</BookingContext.Provider>;
}

export function useBooking() {
  const ctx = useContext(BookingContext);
  if (!ctx) throw new Error('useBooking must be used inside <BookingProvider>');
  return ctx;
}
